<div style="font-size: 12px; width: 100%;">
    <div class="panel-body">

      <div>
        <!-- <mat-spinner  mode="indeterminate"
          class="circle" style="margin: 15px auto;"  diameter="20">
        </mat-spinner> -->
        <mat-grid-list cols="4" rowHeight="25px" >
            <a href="https://portal.dickerdata.com.au/" target="_blank">&nbsp;&nbsp;Tenant Management</a>
        </mat-grid-list>
      </div>

    </div>
  </div>